export const MobileAppConvenienceBannerTexts = {
  title: 'В приложении удобнее',
};
